import { commentsItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100/80 border border-secondary-200/60 text-secondary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-chat-1-line text-sm"></i>
            读者热评
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">吃瓜群众怎么说</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">来自真实网友的热门评论，围观吃瓜第一线的声音。</p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-4">
          {commentsItems.map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
                  <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-100">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors duration-200">
                      <i className="ri-thumb-up-line text-sm"></i>
                      {comment.likes.toLocaleString()}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors duration-200">
                      <i className="ri-chat-3-line text-sm"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}